<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import JiminnyPhone from './jiminny-phone'
  import EventBus from '@/lib/event-bus'
  import notyMixin from '@/helpers/noty'
  import * as Notifications from '../notifications'

  const { mapState, mapActions } = createNamespacedHelpers('conference')

  export default {
    mixins: [
      notyMixin
    ],
    created () {
      EventBus.$on('JOIN_CONFERENCE_CALL', this.joinConferenceCall)
      EventBus.$on('LEAVE_CONFERENCE_CALL', this.leaveConferenceCall)
    },
    beforeDestroy () {
      EventBus.$off('JOIN_CONFERENCE_CALL', this.joinConferenceCall)
      EventBus.$off('LEAVE_CONFERENCE_CALL', this.leaveConferenceCall)
    },
    computed: mapState([
      'activity'
    ]),
    methods: {
      ...mapActions([
        'exitCallScreen'
      ]),
      async joinConferenceCall () {
        try {
          await JiminnyPhone.call({
            activityId: this.activity.id
          })

          this.$_notificationsToCloseOnDestroy.push(
            Notifications.weAreCallingYouNotification({ phoneNumber: this.activity.from.internationalPhoneNumber }).show()
          )
        } catch (error) {
          if (error.response && ![401, 403].includes(error.response.status)) {
            const message = error.response.status === 422
              ? error.response.data.message
              : 'Sorry, your call could not be placed due to an internal error. Please try again later.'

            Notifications.errorNotification({ message }).show()

            this.$router.push('/')
          }
        }
      },
      async leaveConferenceCall () {
        try {
          await JiminnyPhone.disconnect(this.activity.id)
          this.exitCallScreen()
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// jiminny-softphone.vue?242f6086